<template>
    <span
        class="uk-badge"
        :class="colorClass"
        style="text-align: center;"
    >
        {{ formattedValue }}
    </span>
</template>

<script>

import { kebabCaseToWords } from "@strangeanimals/common-vue-components/src/helpers/helpers";

export default {
    name: "BadgeComponent",
    props: {
        value: {
            type: String,
            default: function () {
                return "undefined";
            }
        }
    },
    computed: {
        formattedValue() {
            return kebabCaseToWords(this.value);
        },
        colorClass() {
            let colorClass = '';
            switch ( this.value ) {
            case 'pending':
            case 'take-to-bank':
            case 'confirm-with-bank':
            case 'payment-link-sent':
                colorClass += 'uk-badge-warning';
                break;
            case 'completed':
            case 'received':
                colorClass += 'uk-badge-success';
                break;
            case 'failed':
            case 'cancelled':
                colorClass += 'uk-badge-danger';
                break;
            default:
                colorClass = 'uk-badge-undefined';
            }
            return colorClass;
        }
    }
}
</script>
